/**
 * Cover constructor
 * @constructor app.editor.stage.Cover
 */
 fx.ns("shared.stage", class Cover extends shared.stage.BookArea {
    
	constructor(cover, model, parentContainer, side)
	{
		super(cover, model, parentContainer, side);
	}

	/***************** Getters / Setters *****************/

	get cover()
	{
		return this.data;
	}

	
	/***************** Overrides *****************/
	

	load()
	{
		if (this.stage.loaded)
      		return;

		if (this.displayedSide)
			this.stage.visibleSurface = { x 	: (this.displayedSide == "left") ? 0 : this.pageWidth - this.extraWidth, 
										  width : this.pageWidth };
		
		super.load();

		if ( this.book.cover_option == models.ProductBook.SOFT || 
			 this.book.cover_option == models.ProductBook.HARD || 
			 this.book.cover_option == models.ProductBook.LAYFLAT )
        {
			if (this.sliceBackground)
			{
				this.sliceBackground.css({"cursor": (this.book.hasSlice ? "pointer" : "default")});
				this.sliceBackground.toolTip = this.book.sliceText;
			}
        }

	}

	
	create()
	{
		super.create();
		
		if (!this.displayedSide || this.displayedSide == "left")
		{
			this.qrCode = new fx.components.Image({data : fx.assets.qrCode, className : "qrcode"});

			if (fx.get("book") == "editor" )
				this.qrCode.toolTip = fx.text("Le logo est supprimable au moment du passage de la commande.<br><br>Par contre, le QRCode n'est pas supprimable.");
            
			this._qrCodePosition =(this.book.coverWidth - this.book.sliceWidth) / 2 - 20 - 20.5; 

			this.addChild(this.qrCode, {width : 20.5, height : 32, bottom : 15, left : this._qrCodePosition});
			
		}
	}

	/***************** Actions *****************/

    /*get scale()
    {
        return fx.graphics.getScale(this.stage.node);
    }*/

	selectActivePart(e, possibleSelected)
	{
		super.selectActivePart(e);

		if (!this.stage || !this.stage.node) return;

		let offset = fx.graphics.globalToLocal( this.stage.node, e.pageX, e.pageY ) 

        offset.x = offset.x / this.scale;

        if (this.model.zoom.value < 100)
            return;

        if (possibleSelected)
        {
            let pageWidth = this.data.isCover ? ( (this.book.coverWidth - this.book.sliceWidth)/2) : this.book.pageWidth;
		
		    // show or not slice popup : only if click on background or slice text
		    let slicePosition = (  !(fx.browser.isMobile || fx.browser.isTablet)
                                    && fx.dom.parent(e.target, ".Area") 
                                    && !fx.dom.parent(e.target, ".PageTools") 
                                    && (offset.x > pageWidth) && (offset.x < pageWidth + (this.page.isCover ? this.book.sliceWidth : 0))
                                    );

			if (slicePosition && this.book.hasSlice)
			{
				if ( !this.cover.sliceText )
				{
					this.cover.addSliceText( this.book.coverWidth, this.book.coverHeight, this.model.theme, this.model.customcolors );
					this.delay(this._openSlicePopup, 250);
				}
				else
					this._openSlicePopup();	
			}
	
		}
	}

	_openSlicePopup()
	{
		let sliceComponent = this.stage.getChildFromData( this.cover.sliceText );
		if (sliceComponent)
			this.popup(new shared.popups.SliceEditorPopup(sliceComponent, this.model), { left : fx.dom.offset(this.binding.node).left + this.binding.realWidth * this.scale + 10, top:"center" , modal : false} );
	}


	refresh()
	{
		super.refresh();
	}

	updateChildPositions()
	{
		super.updateChildPositions();

		if (this.displayedSide)
			this.addClass(this.displayedSide);

		this.stage.left(0);

        // TODO : check this out
		/*if (this.loadedFirst)
		{
			this.backgroundLeft.left(0);
			this.backgroundRight.left(this.book.pageWidth + this.extraWidth);
			this.backgroundBinding.left(this.book.pageWidth);
			this.binding.left(this.book.pageWidth);
		}*/
	
	}

	onDataEvent(event)
	{
		super.onDataEvent(event);
		
		if (event.type == "cover-updated")
			this.delay(this._updateCover, 250); // Trick because of double call : TODO to fix 
	}

	_updateCover()
	{
		// manage slice position / size
		if (this.data.sliceText)
		{
			this._lastSlice = {	content : this.data.sliceText.content, 
								text_color : this.data.sliceText.text_color,
								font_family : this.data.sliceText.font_family,
								font_size : this.data.sliceText.font_size };

			this.data.sliceText.delete();
		}

        if (this.book.hasSlice && this._lastSlice && !this.book.cover.sliceText)
			this.data.addSliceText(this.book.coverWidth, this.book.coverHeight, this.model.theme, this.model.customcolors, false, this._lastSlice.content, this._lastSlice.text_color, this._lastSlice.font_family, this._lastSlice.font_size);
	
        if(this.sliceBackground)
        {
            this.sliceBackground.css({"cursor": (this.book.hasSlice ? "pointer" : "default")});
            this.sliceBackground.toolTip = this.book.sliceText;
        }
	}

	
});